import { render } from "./comments-footer.vue?vue&type=template&id=44a95598"
import script from "./comments-footer.vue?vue&type=script&lang=js"
export * from "./comments-footer.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__